import script from "./CategoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTable.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTable.vue?vue&type=style&index=0&id=54f41d8f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f41d8f"]])

export default __exports__